import React from 'react'
import {
    OverContainerSection,
    OverContainer,
    InitialChallenge,
    ClientAndRefer,
    InitialChallengeTypography,
    SectionTitle,
    Refer,
    SectionTwo,
    InitialTwo,
    TypographyHeader,
} from './styles'
import { SectionProps } from 'src/pages'

import { ContentTypography } from 'src/pages/DetailedSuccess/TitleSection/styles'
import { TypographyContent } from 'src/components/common/Typography/typography'
import { useTranslations } from 'src/provider/LocaleProvider'

export function InformationData({ success }: SectionProps) {
    const t = useTranslations()
    return (
        <OverContainerSection>
            <ContentTypography
                marginTop={['medium', 'medium', 'medium', 'xsixty']}
            >
                <TypographyHeader
                    variant={'h1'}
                    fontSize={['xxsuper', 'xxsuper', 'xxxtitle', 'xsuper']}
                    fontWeight={700}
                >
                    {success.title}
                </TypographyHeader>

                <TypographyContent
                    variant={'h2'}
                    fontSize={['xxxsmall', 'xxxsmall', 'large', 'large']}
                    fontWeight={500}
                >
                    {success.functionality}
                </TypographyContent>
            </ContentTypography>
            <OverContainer
                marginTop={['xlarge', 'xlarge', 'xxmedium', 'xxlarge']}
            >
                <InitialChallenge>
                    <SectionTitle marginBottom={'xxxsmall'}>
                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xmedium',
                                'xmedium',
                                'xmedium',
                                'xxmedium',
                            ]}
                            fontWeight={700}
                        >
                            {t('successStories.data.initialChallenge')}
                        </InitialChallengeTypography>
                    </SectionTitle>

                    <InitialChallengeTypography
                        variant={'h2'}
                        fontSize={[
                            'xxxsmall',
                            'xxxsmall',
                            'xxxsmall',
                            'medium',
                        ]}
                        fontWeight={500}
                    >
                        {success.initialChallenge}
                    </InitialChallengeTypography>
                </InitialChallenge>
                <InitialChallenge>
                    <ClientAndRefer
                        marginTop={'xxxsmall'}
                        marginBottom={'xxxsmall'}
                    >
                        <SectionTitle marginRight={'xxxsmall'}>
                            <InitialChallengeTypography
                                variant={'h2'}
                                fontSize={[
                                    'xmedium',
                                    'xmedium',
                                    'xmedium',
                                    'xxmedium',
                                ]}
                                fontWeight={700}
                            >
                                {t('successStories.data.client')}
                            </InitialChallengeTypography>
                        </SectionTitle>
                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={500}
                        >
                            {success.client}
                        </InitialChallengeTypography>
                    </ClientAndRefer>
                    <ClientAndRefer
                        marginTop={'xxxsmall'}
                        marginBottom={'xxxsmall'}
                    >
                        <SectionTitle marginRight={'xxxsmall'}>
                            <InitialChallengeTypography
                                variant={'h2'}
                                fontSize={[
                                    'xmedium',
                                    'xmedium',
                                    'xmedium',
                                    'xxmedium',
                                ]}
                                fontWeight={700}
                            >
                                {t('successStories.data.reference')}
                            </InitialChallengeTypography>
                        </SectionTitle>
                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={500}
                        >
                            <Refer href={success.reference} target={'_blank'}>
                                {success.reference}
                            </Refer>
                        </InitialChallengeTypography>
                    </ClientAndRefer>
                    <ClientAndRefer
                        marginTop={'xxxsmall'}
                        marginBottom={'xxxsmall'}
                    >
                        <SectionTitle marginRight={'xxxsmall'}>
                            <InitialChallengeTypography
                                variant={'h2'}
                                fontSize={[
                                    'xmedium',
                                    'xmedium',
                                    'xmedium',
                                    'xxmedium',
                                ]}
                                fontWeight={700}
                            >
                                {t('successStories.data.category')}
                            </InitialChallengeTypography>
                        </SectionTitle>

                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={500}
                        >
                            {success.category}
                        </InitialChallengeTypography>
                    </ClientAndRefer>
                </InitialChallenge>
            </OverContainer>
            <OverContainer
                marginTop={['xlarge', 'xlarge', 'xxmedium', 'xxlarge']}
            >
                <InitialTwo>
                    <SectionTwo marginBottom={['xxxsmall', 'xxxsmall', 0, 0]}>
                        <SectionTitle marginBottom={'xxxsmall'}>
                            <InitialChallengeTypography
                                variant={'h2'}
                                fontSize={[
                                    'xmedium',
                                    'xmedium',
                                    'xmedium',
                                    'xxmedium',
                                ]}
                                fontWeight={700}
                            >
                                {t('successStories.data.solution')}
                            </InitialChallengeTypography>
                        </SectionTitle>
                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={500}
                        >
                            {success.solution}
                        </InitialChallengeTypography>
                    </SectionTwo>
                </InitialTwo>
                <InitialTwo>
                    <SectionTwo marginBottom={['xxxsmall', 'xxxsmall', 0, 0]}>
                        <SectionTitle marginBottom={'xxxsmall'}>
                            <InitialChallengeTypography
                                variant={'h2'}
                                fontSize={[
                                    'xmedium',
                                    'xmedium',
                                    'xmedium',
                                    'xxmedium',
                                ]}
                                fontWeight={700}
                            >
                                {t('successStories.data.results')}
                            </InitialChallengeTypography>
                        </SectionTitle>
                        <InitialChallengeTypography
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={500}
                        >
                            {success.results}
                        </InitialChallengeTypography>
                    </SectionTwo>
                </InitialTwo>
            </OverContainer>
        </OverContainerSection>
    )
}
